let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Ol4g")).then(() => parcelRequire('dSHkM'));